import { render, staticRenderFns } from "./add.vue?vue&type=template&id=8437a3f4&scoped=true"
import script from "./add.vue?vue&type=script&lang=js"
export * from "./add.vue?vue&type=script&lang=js"
import style0 from "./add.vue?vue&type=style&index=0&id=8437a3f4&prod&scoped=true&lang=less"
import style1 from "./add.vue?vue&type=style&index=1&id=8437a3f4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8437a3f4",
  null
  
)

export default component.exports